import React from 'react';
import '../Navbar/Nav.css';
import { Link as ScrollLink } from 'react-scroll';
import { useDarkMode } from '../../context/DarkModeContext';

function Nav() {
  const { darkMode } = useDarkMode();

  return (
    <nav className={`navbar${darkMode ? ' dark-mode' : ''}`}>
      <div className="container">
        <div className="nav-logo" />
        <div className="nav-elements">
          <ul className="nav-links">
            <li className="nav-item">
              <ScrollLink className="nav-link" to="hero" spy={true} smooth={true} duration={500} offset={-48}>Home</ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink className="nav-link" to="about" spy={true} smooth={true} duration={500} offset={-48}>About</ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink className="nav-link" to="projects" spy={true} smooth={true} duration={500} offset={-48}>Projects</ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink className="nav-link" to="blog" spy={true} smooth={true} duration={500} offset={-48}>Blog</ScrollLink>
            </li>
            <li className="nav-item">
              <ScrollLink className="nav-link" to="contact" spy={true} smooth={true} duration={500} offset={-48}>Contact</ScrollLink>
            </li>
          </ul>

        </div>
      </div>
    </nav>
  );
}

export default Nav;
